import React from 'react';
import { FileCheck } from 'lucide-react';
export function ForDevelopers() {
  return <section id="what-we-test" className="py-12 md:py-20 bg-white" data-id="element-84">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-85">
        <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 md:p-12 border border-gray-100" data-id="element-86">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-16" data-id="element-87">
            <div className="lg:w-2/3" data-id="element-88">
              <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6" data-id="element-89">
                What Laravel Skills Are Tested?
              </h2>
              <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8" data-id="element-90">
                Each test evaluates 12 core Laravel competencies through
                practical, real-world code challenges — not theoretical trivia.
                Here's what candidates are assessed on:
              </p>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3 sm:gap-y-4 mb-6 sm:mb-8" data-id="element-91">
                <li className="flex items-start" data-id="element-92">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-93" />
                  <span className="text-sm sm:text-base" data-id="element-94">
                    Service Providers: Registration and configuration
                  </span>
                </li>
                <li className="flex items-start" data-id="element-95">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-96" />
                  <span className="text-sm sm:text-base" data-id="element-97">
                    Blade Templating: Custom directives and advanced techniques
                  </span>
                </li>
                <li className="flex items-start" data-id="element-98">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-99" />
                  <span className="text-sm sm:text-base" data-id="element-100">
                    Validation: Custom rules and complex scenarios
                  </span>
                </li>
                <li className="flex items-start" data-id="element-101">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-102" />
                  <span className="text-sm sm:text-base" data-id="element-103">
                    Authorization: Gates and policies for access control
                  </span>
                </li>
                <li className="flex items-start" data-id="element-104">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-105" />
                  <span className="text-sm sm:text-base" data-id="element-106">
                    Queues and Jobs: Background tasks and job processing
                  </span>
                </li>
                <li className="flex items-start" data-id="element-107">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-108" />
                  <span className="text-sm sm:text-base" data-id="element-109">
                    Eloquent ORM: Relationships and eager loading
                  </span>
                </li>
                <li className="flex items-start" data-id="element-110">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-111" />
                  <span className="text-sm sm:text-base" data-id="element-112">
                    Middleware: Route restrictions and application flow
                  </span>
                </li>
                <li className="flex items-start" data-id="element-113">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-114" />
                  <span className="text-sm sm:text-base" data-id="element-115">
                    Redis and Caching: Configuration and session management
                  </span>
                </li>
                <li className="flex items-start" data-id="element-116">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-117" />
                  <span className="text-sm sm:text-base" data-id="element-118">
                    Database Migrations: Implementation and rollbacks
                  </span>
                </li>
                <li className="flex items-start" data-id="element-119">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-120" />
                  <span className="text-sm sm:text-base" data-id="element-121">
                    Testing: PHPUnit integration and Laravel Dusk
                  </span>
                </li>
                <li className="flex items-start" data-id="element-122">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-123" />
                  <span className="text-sm sm:text-base" data-id="element-124">
                    Security: CSRF protection and encryption
                  </span>
                </li>
                <li className="flex items-start" data-id="element-125">
                  <FileCheck size={20} className="text-primary flex-shrink-0 mt-0.5 mr-2 sm:mr-3" data-id="element-126" />
                  <span className="text-sm sm:text-base" data-id="element-127">
                    API Development: RESTful practices and authentication
                  </span>
                </li>
              </ul>
              <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8" data-id="element-128">
                Your test results can serve as a first step toward official
                Certification for Laravel, showcasing your skills to potential
                employers.
              </p>
              <a href="https://certificationforlaravel.testportal.com/test.html?t=Xj7qVzGX8p3c" className="inline-block px-6 py-3 bg-primary text-white rounded-2xl hover:bg-primary/90 transition-colors font-medium" data-id="element-129">
                Try the free sample questions
              </a>
            </div>
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-130">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-fit overflow-hidden w-full max-w-sm" data-id="element-131">
                <img src="https://cdn.magicpatterns.com/uploads/3YAj3JVMj6i59zRiGSYLWp/Recruitment_test_logo_square.png" alt="Laravel Test Topics Covered" className="w-full h-auto" data-id="element-132" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}